import ChargeList from "./ChargeList";

export default {
    list: ChargeList,
}
